import {
  IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem,
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useLevelSubscriptionDropDownData } from "../../hooks/dropdown/useLevelSubscriptionDropDownData";
import { useEffect, useState } from "react";

type DisplayLevelSubscriptionDropDownProps = {
  selectedProductValue: string;
  selectedVersionValue: string;
  callbackFn?: (v: any, options: any) => void;
  label?: string;
};

export const DisplayLevelSubscriptionDropDown: React.FC<
  DisplayLevelSubscriptionDropDownProps
> = ({ callbackFn, selectedProductValue, selectedVersionValue, label }) => {
  //  const { t } = useTranslation();

  const { t } = useTranslation();

  const [subscriptionLevels, setSubscriptionLevels] =
    useState<IdentityMelcoModelsGenericList1MelcoModelsSubscriptionListItem>();

  let allLevelSubscription = useLevelSubscriptionDropDownData(
    selectedProductValue,
    selectedVersionValue
  );

  useEffect(() => {
    if (allLevelSubscription && allLevelSubscription.status === "success") {
      setSubscriptionLevels(allLevelSubscription.data);
    }
  }, [allLevelSubscription]);

  return (
    <SelectField
      name="subscription_code"
      label={label ?? t("licenses.basic.search.level.title")}
      options={(subscriptionLevels ? subscriptionLevels.list : []).map(
        (levelSub) => {
          return {
            label: levelSub.product_level_name!,

            value: levelSub.product_level_code!,
          };
        }
      )}
      showSearch
      optionFilterProp="label"
      onChange={(value, subscription) => {
        if (callbackFn) callbackFn(value, subscription);
      }}
    />
  );
};
